module.exports = __webpack_public_path__ + "static/media/user.6446b861.svg";